import { apiClient } from './api';

export interface AuditLogEntry {
  id: string;
  timestamp: string;
  actor: {
    id: string;
    name: string;
    email: string;
  };
  action: string;
  target: {
    type: string;
    id: string;
  };
  ipAddress: string;
  userAgent: string;
  details: Record<string, unknown>;
}

export interface AuditLogFilters {
  page?: number;
  limit?: number;
  dateFrom?: string;
  dateTo?: string;
  actor?: string;
  action?: string;
}

export interface AuditLogsResponse {
  data: AuditLogEntry[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const auditService = {
  getAuditLogs: async (filters: AuditLogFilters = {}): Promise<AuditLogsResponse> => {
    const response = await apiClient.get('/admin/audit-logs', { params: filters });
    return response.data.data;
  },

  getAuditLogById: async (id: string): Promise<AuditLogEntry> => {
    const response = await apiClient.get(`/admin/audit-logs/${id}`);
    return response.data.data;
  },
};

export default auditService;
